"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.borderWidthThick = exports.borderWidthMedium = exports.borderWidthThin = exports.controlBorderWidthThick = exports.controlBorderWidthMedium = exports.controlBorderWidthThin = exports.actionBorderWidthThick = exports.actionBorderWidthMedium = exports.actionBorderWidthThin = exports.baseBorderWidthThick = exports.baseBorderWidthMedium = exports.baseBorderWidthThin = void 0;
exports.baseBorderWidthThin = 1;
exports.baseBorderWidthMedium = 2;
exports.baseBorderWidthThick = 4;
exports.actionBorderWidthThin = 1;
exports.actionBorderWidthMedium = 2;
exports.actionBorderWidthThick = 4;
exports.controlBorderWidthThin = 1;
exports.controlBorderWidthMedium = 2;
exports.controlBorderWidthThick = 4;
exports.borderWidthThin = 1;
exports.borderWidthMedium = 2;
exports.borderWidthThick = 4;